import { NewSelectionFilter, SelectionFilterApi } from '@api/twin/SelectionFilterApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePluginTranslation } from '@translation';

export const usePostSelectionFilter = (projectId: number) => {
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;
  const queryClient = useQueryClient();
  const { t } = usePluginTranslation();

  return useMutation({
    mutationFn: async (t: { selectionFilter: NewSelectionFilter }) =>
      await SelectionFilterApi(client).postSelectionFilter(projectId, t.selectionFilter),
    onMutate: () => {
      return viewer.notificationCenter.pushNotification({
        type: t('selection_plugin.notification.notification_title'),
        status: 'pending',
        message: t('selection_plugin.notification.loading.text'),
        title: t('selection_plugin.notification.notification_title'),
        displayed: true,
      });
    },
    onSuccess: (_data, _variables, notificationId) => {
      queryClient.invalidateQueries({
        queryKey: ['SelectionFilter', projectId],
      });
      viewer.notificationCenter.pushNotification({
        type: t('selection_plugin.notification.notification_title'),
        status: 'success',
        message: t('selection_plugin.notification.success.text'),
        title: t('selection_plugin.notification.notification_title'),
        displayed: true,
      }, notificationId);
    },
    onError: (_error, _variables, notificationId) => {
      viewer.notificationCenter.pushNotification({
        type: t('selection_plugin.notification.notification_title'),
        status: 'error',
        message: t('selection_plugin.notification.error.text'),
        title: t('selection_plugin.notification.notification_title'),
        displayed: true,
      }, notificationId);
    },
  });
};
